export const INSTAGRAM_HANDLE = 'vanstringcm';
export const INSTAGRAM_URL = `https://www.instagram.com/${INSTAGRAM_HANDLE}/`;
export const INSTAGRAM_SINCE = 2018;
export const BEHOLD_FEED_ID = 'dTFgx3LDWB8tSTNfhwi8';
